<template>
    <div class="form-input" :class="{disabled}">
        <label v-if="label !== ''">{{ label }} <span v-if="required" class="required">*</span></label>
        <div class="input">
            <textarea type="text" :placeholder="placeholder" :value="value" @input="handleInput" @change="change" :disabled="disabled" ref="input"></textarea>
        </div>
    </div>
</template>

<script>
export default {
    name: "input-textarea",
    props:{
        value:String,
        label:String,
        placeholder:String,
        required:Boolean,
        disabled:Boolean,
    },
    methods:{
        handleInput(e){
            this.$emit("input",e.target.value)
        },
        change(e){
            this.$emit("change",e.target.value)
        },
        focusInput(){
            this.$refs["input"].focus();
        },
        selectInput(){
            this.$refs["input"].select();
        }
    }
}
</script>